import * as React from 'react';
import * as ReactDom from 'react-dom';
import {Button} from 'semantic-ui-react';

export class Main extends React.Component<{}, {}> {
    render() {
        return (
            <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
                <div style={{backgroundColor: "#c61a1b", padding: "20px"}}>
                    <img src="resources/assets/logo_white.png" style={{marginRight: "10px", verticalAlign: "middle", height: "34px"}}/>
                    <span style={{color: "#f1f1f1", fontSize: "15px"}}>Bryx 911 Universal</span>
                </div>
                <div id="banner">
                    <div id="bannerText">
                        <div id="bannerText-title">
                            Bryx 911 Universal Application
                        </div>
                        <div id="bannerText-subtext">
                            Download Now
                        </div>
                        <div id="downloadButtons">
                            <Button id="windowsButton" className="downloadButton" inverted href="files/bryx911ua-latest.exe" style={{ marginRight: "10px" }}>
                                Windows
                            </Button>
                            <Button id="macButton" className="downloadButton" inverted href="files/bryx911ua-latest.dmg" style={{ marginLeft: "10px" }}>
                                Mac
                            </Button>
                        </div>
                    </div>
                    <img src="resources/assets/screen_1_together.png"/>
                </div>
            </div>
        );
    }
}

ReactDom.render(
    <Main/>,
    document.getElementById("content"),
);



// WEBPACK FOOTER //
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/tslint-loader!./index.tsx